/**
 * PF Back-In-Stock (BIS) widget — extracted from main-product-cro.liquid.
 *
 * Liquid-provided data (customer email, variant availability, section id) is
 * injected via the #pf-bis-data JSON island the section renders alongside this
 * script. Everything below is static and lives in an asset so the PDP HTML
 * stays lean. Debug: set window.PF_DEBUG_BIS = true in the console.
 */
(function () {
  var dataEl = document.getElementById('pf-bis-data');
  if (!dataEl) return;

  var PF_BIS_DATA = {};
  try {
    PF_BIS_DATA = JSON.parse(dataEl.textContent) || {};
  } catch (e) {
    return;
  }

  var SECTION_ID = PF_BIS_DATA.sectionId;
  var SHOPIFY_EMAIL = PF_BIS_DATA.customerEmail || '';
  var variants = PF_BIS_DATA.variants || [];

  // Debug toggle: in console set window.PF_DEBUG_BIS = true
  window.PF_DEBUG_BIS = window.PF_DEBUG_BIS ?? false;
  function log(){ if (window.PF_DEBUG_BIS && console) console.log.apply(console, arguments); }

  // --- Helpers -------------------------------------------------------------
  function $(id){ return document.getElementById(id); }
  function q(sel){ return document.querySelector(sel); }

  window.PF_LAST_VID = null;
  function getSelectedVariantId(){
    // A) try the canonical add-to-cart input (when it exists)
    var el = document.querySelector('form[action*="/cart/add"] [name="id"]');
    if (el && el.value) return el.value;

    // B) fall back to what Liquid put on our button (works even if BIS is above buy-buttons)
    var btn = document.getElementById('pf-bis-btn');
    if (btn && btn.dataset.variantId) return btn.dataset.variantId;

    // C) fall back to URL ?variant=
    try {
      var v = new URLSearchParams(location.search).get('variant');
      if (v) return v;
    } catch(e){}

    return null;
  }

  var variantAvail = {};
  for (var i=0;i<variants.length;i++){ variantAvail[variants[i].id] = variants[i].available; }
  function withTimeout(promise, ms){
    return new Promise(function(resolve){
      var t = setTimeout(function(){ resolve(null); }, ms);
      promise.then(function(v){ clearTimeout(t); resolve(v); }, function(){ clearTimeout(t); resolve(null); });
    });
  }

  function getKlaviyoEmail(){
    return new Promise(function(resolve){
      try {
        if (window._learnq && Array.isArray(window._learnq)) {
          window._learnq.push(['get', 'email', function(email){
            resolve((email && typeof email === 'string') ? email : null);
          }]);
          return;
        }
      } catch(e){ log('Klaviyo get email error', e); }
      resolve(null);
    });
  }

  function trackBackInStockEvent(payload){
    try {
      if (window._learnq && Array.isArray(window._learnq)) {
        window._learnq.push(['track', 'BackInStockRequest', payload]);
        return true;
      }
    } catch(e){ log('Klaviyo track error', e); }
    return false;
  }

  function showFallbackForm() {
    var wrap = $('pf-bis-form-wrapper');
    if (!wrap) return;
    wrap.classList.remove('pf-offscreen');
    wrap.style.minHeight = '220px';

    // Nudge Klaviyo to mount if needed (safe no-ops if unavailable)
    try {
      if (window.klaviyoForms && typeof window.klaviyoForms.load === 'function') {
        window.klaviyoForms.load();
      } else if (window._learnq && Array.isArray(window._learnq)) {
        window._learnq.push(['openForm', 'TRX6SD']);
      }
    } catch(e){}

    // Retry once if iframe hasn't injected yet
    setTimeout(function(){
      var hasIframe = wrap.querySelector('iframe');
      if (!hasIframe && window.klaviyoForms && typeof window.klaviyoForms.load === 'function') {
        try { window.klaviyoForms.load(); } catch(e){}
      }
    }, 400);
  }

  function hideFallbackForm() {
    var wrap = $('pf-bis-form-wrapper');
    if (!wrap) return;
    wrap.classList.add('pf-offscreen');
  }

  function refreshForSelectedVariant(force){
    var container = document.getElementById('pf-bis');
    var btn = document.getElementById('pf-bis-btn');
    var status = document.getElementById('pf-bis-status');
    var buyWrap = document.getElementById('pf-buy-buttons-wrap');
    var qtyForm = document.getElementById('Quantity-Form-' + SECTION_ID);
    var priceEl = document.getElementById('price-' + SECTION_ID);
    if (!container || !btn) return;

    var vid = getSelectedVariantId();

    // If we still don't have a variant id yet (because buy-buttons hasn't rendered),
    // DON'T hide the block; just keep current state and try again later.
    if (!vid) return;

    // update button data
    btn.dataset.variantId = vid;

    // only toggle visibility once we know the selected variant
    var isOOS = !variantAvail[vid];
    container.hidden = !isOOS;
    if (buyWrap) buyWrap.style.display = isOOS ? 'none' : '';
    if (qtyForm) qtyForm.style.display = isOOS ? 'none' : '';
    if (priceEl) priceEl.classList.toggle('pf-price-oos', isOOS);

    // reset UI only if variant actually changed or this is a forced init
    var changed = (window.PF_LAST_VID !== vid);
    if (changed || force === true){
      window.PF_LAST_VID = vid;
      if (isOOS && status){
        status.classList.remove('is-visible','pf-ok','pf-need');
        status.textContent = '';
        hideFallbackForm();
      }
    }
  }

  async function onClickNotify(e){
    var btn    = document.getElementById('pf-bis-btn');
    var status = document.getElementById('pf-bis-status');
    if (!btn) return;

    function setStatus(txt, cls){
      if (!status) return;
      status.textContent = txt;
      status.classList.remove('pf-ok','pf-need','is-visible');
      if (cls) status.classList.add(cls);
      status.classList.add('is-visible');
    }

    var payload = {
      product_id: btn.dataset.productId,
      product_title: btn.dataset.productTitle,
      product_url: btn.dataset.productUrl,
      variant_id: btn.dataset.variantId,
      variant_title: btn.dataset.variantTitle
    };

    // 1) If Shopify knows the email, confirm immediately (no form flash)
    if (SHOPIFY_EMAIL) {
      payload.$email = SHOPIFY_EMAIL;
      trackBackInStockEvent(payload);
      setStatus("You’re all set — we’ll email you when it’s back in stock.", 'pf-ok');
      PF_BIS.hide();
      return;
    }

    // 2) Unknown initially → show guidance + form IMMEDIATELY
    //setStatus("Almost there — enter your email to be notified.", 'pf-need');
    PF_BIS.show();

    // 3) In the background, try to identify quickly. If we succeed, convert to success and hide the form.
    let kEmail = await Promise.race([
      withTimeout(getKlaviyoEmail(), 900),                 // quick attempt
      new Promise(r => setTimeout(() => r(null), 900))     // hard cap so UI never waits
    ]);

    if (kEmail) {
      payload.$email = kEmail;
      trackBackInStockEvent(payload);
      setStatus("You’re all set — we’ll email you when it’s back in stock.", 'pf-ok');
      PF_BIS.hide();
    }
  }
  // ✅ make the handler callable from inline HTML
  window.PF_onClickNotify = window.PF_onClickNotify || onClickNotify;

  // Capture-phase delegation (runs even if other code stops bubbling)
  document.addEventListener('click', function(e){
    var t = e.target;
    if (!t) return;
    if (t.id === 'pf-bis-btn' || (t.closest && t.closest('#pf-bis-btn'))) {
      if (typeof window.PF_onClickNotify === 'function') {
        window.PF_onClickNotify(e);
      } else if (typeof onClickNotify === 'function') {
        onClickNotify(e);
      } else if (window.PF_BIS && PF_BIS.show) {
        PF_BIS.show();  // last-resort fallback
      }
    }
  }, true);

  // Bind once (and re-bind on DOM changes for dynamic themes)
  function bind(skipRefresh){
    var btn = document.getElementById('pf-bis-btn');
    if (btn && !btn._pfBound) {
      btn.addEventListener('click', onClickNotify);
      btn._pfBound = true;
    }
    if (!skipRefresh) refreshForSelectedVariant(true); // first run
  }
  bind(false);

  // Track whether the ATC input exists yet
  var hadIdInput = !!document.querySelector('form[action*="/cart/add"] [name="id"]');

  var obs = new MutationObserver(function(){
    // rebind in case nodes were swapped
    bind(true);

    // if the add-to-cart variant input just appeared, refresh now
    var hasNow = !!document.querySelector('form[action*="/cart/add"] [name="id"]');
    if (hasNow && !hadIdInput){
      hadIdInput = true;
      refreshForSelectedVariant(true);
    }
  });
  obs.observe(document.body, { childList:true, subtree:true });

  // also keep the existing listeners:
  var idInput = document.querySelector('form[action*="/cart/add"] [name="id"]');
  if (idInput) idInput.addEventListener('change', function(){ refreshForSelectedVariant(true); });
  document.addEventListener('change', function(e){
    var t = e.target;
    if (!t) return;
    if (t.name === 'id' || (t.closest && (t.closest('fieldset') || t.closest('select')))) {
      setTimeout(function(){ refreshForSelectedVariant(true); }, 0);
    }
  });
  document.addEventListener('variant:change', function(){ refreshForSelectedVariant(true); });
  // expose manual toggles (used by our CSS/visibility helpers)
  window.PF_BIS = { show: showFallbackForm, hide: hideFallbackForm };

})();
